import { render, staticRenderFns } from "./RespondedMsg.vue?vue&type=template&id=1ea77579&"
import script from "./RespondedMsg.vue?vue&type=script&lang=js&"
export * from "./RespondedMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports